<div id="spinner" class="blur">
<div id="progressLoader" class="progress-loader" *ngIf="isCardEnabled">
    <div id="cardLoading" class="card-loading" [hidden]="!loading">
        <div id="loadingSpinner" [ngClass]="isCardEnabled?'card-spinner':'loading-spinner'">
            <div id="spinnerBorder" class="spinner-border text-primary" [ngClass]="{'loader':isCardEnabled}" role="status">
                <span class="visually-hidden loading-message"></span>
            </div>
        </div>
        <div id="spinnerSwitchText" class="switch-text"><span i18n="@@ipos-spinner-overlay.switching-retail-hq">Switching Retail HQ</span></div>
    </div>
</div>
</div>
<div id="progressLoaderHidden" *ngIf="!isCardEnabled" class="progress-loader" [hidden]="!loading">
    <ng-container *ngTemplateOutlet='spinner'></ng-container>
</div>
<div *ngIf="isActiveUserSpinner">
    <ng-container *ngTemplateOutlet='spinner'></ng-container>
</div>
<ng-template #spinner>
    <div id="cardSpinner" [ngClass]="isCardEnabled?'card-spinner':'loading-spinner'">
        <div id="cardSpinnerBorder" class="spinner-border text-primary" [ngClass]="{'loader':isCardEnabled}" role="status">
            <span class="visually-hidden loading-message"></span>
        </div>
    </div>
</ng-template>